<template>
  <div class="receipt-document font-xolonium-bold-force" :key="t">
    <!-- Frente -->
    <div class="page page-front">
      <div class="page-content">
        <Miniature />

        <CompanyMiniature :key="companySelected" v-if="companyMiniature" />

        <Frente />

        <!-- assinatura -->
        <CertificateSignatures :signatures="signatures" page="front" />

        <div
          class="field name uppercase"
          :style="[
            collaborator?.name?.length <= 31
              ? 'width: 68.5%; font-size: 1.5em; right: 85mm; top: 95mm;'
              : 'width: 70%; font-size: 1.3em; top: 90mm; ',
          ]"
        >
          {{ collaborator?.name }}
        </div>
        <div class="field description font-xolonium-force">
          CPF: {{ formatCpf(collaborator?.cpf) }} {{ description }}
        </div>
        <div class="field location">{{ location }}</div>
      </div>
    </div>

    <!-- Verso -->
    <div class="page page-back">
      <div class="page-content">
        <Verso />

        <CertificateValidationQr
          :validation-url="
            certificate?.qr_code_payload || certificate?.validation_url
          "
          :public-code="certificate?.public_code"
        />

        <div
          class="field aproveitamento"
          :style="[aproveitamento == 100 ? 'left: 35mm;' : 'left: 30mm;']"
        >
          {{ aproveitamento }}%
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CertificateValidationQr from "@/components/CertificateValidationQr.vue";
import CompanyMiniature from "@/components/CompanyMiniature.vue";
import Frente from "@/components/Frente.vue";
import Miniature from "@/components/Miniature.vue";
import CertificateSignatures from "@/components/signatures/CertificateSignatures.vue";
import Verso from "@/components/Verso.vue";
import { appStore } from "@/store";
import { computed, defineProps } from "vue";

const t = computed(() => appStore.getters.getTrainingSelected);
const companyMiniature = computed(() => appStore.state.companies.miniature);
const companySelected = computed(() => appStore.state.companies.m_company);

defineProps({
  collaborator: { type: Object, required: true },
  training: { type: String, required: true },
  aproveitamento: { type: String, required: true },
  description: { type: String, required: true },
  location: { type: String, required: true },
  signatures: {
    type: Array,
    default: () => [],
  },
  certificate: {
    type: Object,
    default: null,
  },
});

function formatCpf(text) {
  const badchars = /[^\d]/g;
  const mask = /(\d{3})(\d{3})(\d{3})(\d{2})/;
  const cpf = new String(text).replace(badchars, "");
  return cpf.replace(mask, "$1.$2.$3-$4");
}
</script>

<style scoped>
.receipt-document {
  padding: 0;
  box-sizing: border-box;
}

.page {
  position: relative;
  width: 297mm;
  height: 210mm;
  overflow: hidden;
}

.page-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.page-front {
  /* page-break-after: always;
  break-after: page;
  page-break-inside: avoid; */
}

.page-back {
  page-break-after: auto;
  break-after: auto;
  page-break-inside: avoid;
}

.field {
  position: absolute;
  font-size: 12pt;
  color: #000;
  z-index: 1;
}

@media print {
  @page {
    margin: 0;
  }
  body {
    margin: 0;
  }
  .page {
    position: relative;
    width: 297mm;
    height: 210mm;
    overflow: hidden;
  }

  .page-front {
    /* page-break-after: always;
    break-after: page; */
  }

  .page:last-child {
    page-break-after: auto;
    break-after: auto;
  }

  .page-content,
  .bg-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.field.training {
  top: 110mm;
  left: 30mm;
}
.field.name {
  text-align: center;
  text-transform: uppercase;
}
.field.cpf {
  top: 95mm;
  left: 30mm;
}
.field.description {
  text-align: justify;
  top: 118mm;
  left: 18mm;
  width: 65%;
  font-size: 0.95em;
}
.field.location {
  width: 80%;
  top: 150mm;
  text-align: end;
  right: 40mm;
  font-size: 0.65em;
}
.field.aproveitamento {
  width: 78.5%;
  top: 100mm;
  text-align: end;
  font-size: 3em;
}
</style>
